(function () {
  'use strict';

  angular.module('unit.payment').controller('unitPaymentCtrl', unitPaymentCtrl);

  unitPaymentCtrl.$inject = ['UnitPayment', 'moment'];

  function unitPaymentCtrl(UnitPayment, moment) {
    var vm = this;

    vm.payment = {
      payment_type: '1',
      discount: 0,
      payment_date: moment().format('YYYY-MM-DD'),
    };

    if (vm.unit.lead_unit_assn.deal) {
      if (vm.unit.lead_unit_assn.deal.payment_type == '1') {
        vm.payment.amount = +vm.unit.lead_unit_assn.deal.deal_total;
        vm.payment.payment_type = '2';
      } else if (vm.unit.lead_unit_assn.deal.payment_type == '2') {
        vm.payment.amount = +vm.unit.lead_unit_assn.deal.period_payment;
        vm.payment.payment_type = '3';
      }
    }

    vm.save = function (payment) {
      payment.lua_id = vm.unit.lead_unit_assn.id;

      UnitPayment.create(payment, function (response) {
        vm.onSave(response);
      });
    };

    vm.cancel = function () {
      vm.onCancel();
    };
  }
})();
